import { apiRequest, deleteResource, getResource } from "../api/http";

export function getChannel(channel_id) {
  return getResource(`/api/channel/get-channel/${channel_id}`, {
    select: (data) => data.channel,
    fallback: [],
  });
}

export function getChannelList() {
  return getResource("/api/channel/get-all-channels");
}

export function updateChannel(obj, channel_id) {
  return apiRequest("put", `/api/channel/update-channel/${channel_id}`, {
    data: obj,
  });
}

export function updateChannelThumbnail(obj, thumbnail_id) {
  return apiRequest(
    "put",
    `/api/channel/update-channel-thumbnail/${thumbnail_id}`,
    { data: obj }
  );
}

export function deleteChannel(channel_id) {
  return deleteResource(`/api/channel/delete-channel/${channel_id}`);
}

export function createChannel(generalInfo) {
  return apiRequest("post", "/api/channel/create-channel", {
    data: generalInfo,
    rethrow: true,
  });
}
